package com.shadowings.gero.presentation.component

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedCard
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.FeaturePollOption
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.feature_poll_free_text_label
import gero.composeapp.generated.resources.feature_poll_option_character_accessories
import gero.composeapp.generated.resources.feature_poll_option_new_chapters
import gero.composeapp.generated.resources.feature_poll_option_new_quiz_modes
import gero.composeapp.generated.resources.feature_poll_option_review_section
import gero.composeapp.generated.resources.feature_poll_submit_button
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

private fun FeaturePollOption.labelRes(): StringResource = when (this) {
    FeaturePollOption.NewChapters -> Res.string.feature_poll_option_new_chapters
    FeaturePollOption.NewQuizModes -> Res.string.feature_poll_option_new_quiz_modes
    FeaturePollOption.ReviewSection -> Res.string.feature_poll_option_review_section
    FeaturePollOption.CharacterAccessories -> Res.string.feature_poll_option_character_accessories
}

@Composable
fun FeaturePollForm(
    selectedOption: FeaturePollOption?,
    onOptionSelected: (FeaturePollOption) -> Unit,
    freeText: String,
    onFreeTextChange: (String) -> Unit,
    onSubmit: () -> Unit,
    modifier: Modifier = Modifier,
) {

    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        FeaturePollOption.entries.forEach { option ->
            val selected = option == selectedOption
            OutlinedCard(
                onClick = { onOptionSelected(option) },
                shape = RoundedCornerShape(12.dp),
                colors = CardDefaults.outlinedCardColors(
                    containerColor = if (selected) {
                        MaterialTheme.colorScheme.primaryContainer
                    } else {
                        MaterialTheme.colorScheme.surfaceVariant
                    }
                ),
                border = BorderStroke(
                    width = if (selected) 2.dp else 1.dp,
                    color = if (selected) {
                        MaterialTheme.colorScheme.primary
                    } else {
                        MaterialTheme.colorScheme.outline.copy(alpha = 0.5f)
                    }
                ),
                modifier = Modifier
                    .fillMaxWidth()
                    .semantics { testTag = "feature_poll_option_${option.analyticsKey}" }
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 16.dp, vertical = 8.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    RadioButton(selected = selected, onClick = null)
                    Spacer(Modifier.width(12.dp))
                    Text(
                        text = stringResource(option.labelRes()),
                        style = MaterialTheme.typography.bodyMedium
                    )
                }
            }
        }

        OutlinedTextField(
            value = freeText,
            onValueChange = onFreeTextChange,
            label = { Text(stringResource(Res.string.feature_poll_free_text_label)) },
            minLines = 2,
            modifier = Modifier
                .fillMaxWidth()
                .semantics { testTag = "feature_poll_free_text" }
        )

        GeroButton(
            modifier = Modifier.fillMaxWidth().height(56.dp),
            enabled = selectedOption != null,
            title = stringResource(Res.string.feature_poll_submit_button),
            testTagId = "feature_poll_btn_submit",
            onClick = onSubmit
        )
    }
}
